import { Quote } from '@britishcouncil/react-solas-ors3';

export const UaeWarningMsg = () => (
  <Quote intent="warning" title="">
    <p>
      Please ensure to submit the below documents within three working days of registering online or else your
      registration will remain incomplete:
    </p>
    <ol type="I">
      <li>Copy of registration summary after payment</li>
      <li>Three recent passport size photographs</li>
      <li>Copy of Passport or Emirates ID (as registered online)</li>
      <li>Copy of previous statement of result ( If applicable)</li>
      <li>No objection Certificate from school (If applicable)</li>
      <li>Child Protection Form ( from age 18 and below)</li>
      <li>Authorisation letter if the candidate is not physically present</li>
    </ol>
    <p>You can find the following documents here :</p>
    <p>
      <a href="https://www.britishcouncil.ae/en/exam/igcse-school/register/candidates">
        https://www.britishcouncil.ae/en/exam/igcse-school/register/candidates
      </a>
    </p>
  </Quote>
);
